import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ unread: 0, action_total: 0, per_status: {}, action_orders: [], refresh: () => {} });

// Polling ringan (30s) SATU kali untuk seluruh admin UI (sidebar, bell, dashboard, halaman pesanan).
export function ShopNotifProvider({ enabled, children }) {
  const [data, setData] = useState({ unread: 0, action_total: 0, per_status: {}, action_orders: [] });

  const refresh = useCallback(() => {
    if (!enabled) return;
    api.get("/admin/shop/notifications/summary").then((r) => setData(r.data)).catch(() => {});
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [enabled, refresh]);

  return <Ctx.Provider value={{ ...data, refresh }}>{children}</Ctx.Provider>;
}

export const useShopNotif = () => useContext(Ctx);
